export const COMMON_STATUS_LABELS = {
	valid: '有效',
	invalid: '无效',
	deleted: '删除',
	delete: '已删除',
	undo: '已撤销'
}

export const COMMON_STATUS_COLORS = {
	valid: 'success',
	invalid: 'grey',
	deleted: 'error',
	delete: 'error',
	undo: 'warning'
}

export const BEAN_TYPE_LABELS = {
	green: '生豆',
	roasted: '熟豆',
	blended: '拼配',
	ground: '粉',
	extract: '萃取',
	capsule: '胶囊',
	pod: '粉囊',
	other: '其他'
}

export const BEAN_TYPE_COLORS = {
	green: 'success',
	roasted: 'brown',
	blended: 'secondary',
	ground: 'secondary',
	extract: 'info',
	capsule: 'info',
	pod: 'info',
	other: 'grey'
}

export const STOCK_LOG_TYPE_LABELS = {
	produce: '生产',
	purchase: '采购',
	sale: '销售',
	return: '退货',
	transferin: '转入',
	transferout: '转出',
	waste: '损耗',
	undo: '撤销'
}

export const STOCK_LOG_TYPE_COLORS = {
	produce: 'primary',
	purchase: 'success',
	sale: 'error',
	return: 'info',
	transferin: 'info',
	transferout: 'warning',
	waste: 'orange',
	undo: 'warning'
}

export const BATCH_TYPE_LABELS = {
	purchase: '采购',
	produce: '生产',
	sale: '销售',
	return: '退货',
	transfer: '转移'
}

export const BATCH_TYPE_COLORS = {
	purchase: 'success',
	produce: 'primary',
	sale: 'error',
	return: 'info',
	transfer: 'warning'
}

export const CUPPING_STATUS_LABELS = {
	valid: '有效',
	invalid: '无效',
	closed: '关闭'
}

export const CUPPING_STATUS_COLORS = {
	valid: 'success',
	invalid: 'grey',
	closed: 'secondary'
}

export const CUPPING_METHOD_LABELS = {
	standard: '标准',
	drip: '滴滤',
	v60: 'V60',
	coldbrew: '冷萃',
	espresso: '意式',
	french: '法压',
	other: '其他'
}

export const STOCK_SRC_LABELS = {
	Roast: '烘焙',
	roast: '烘焙',
	order: '订单',
	user: '手动',
	beanbatch: '批次',
	BeanStockLog: '库存记录',
	purchase: '采购'
}

export const SUPPLIER_TYPE_LABELS = {
	bean: '咖啡豆',
	ingredient: '食材',
	consumable: '耗材'
}

export const SUPPLIER_TYPE_COLORS = {
	bean: 'brown',
	ingredient: 'success',
	consumable: 'grey'
}

export function enumLabel(map, value) {
	if (value == null || value === '') return '—'
	return map[value] || value
}

export function enumColor(map, value, fallback = 'default') {
	return map[value] || fallback
}
